<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0" v-bind:class="{'table-responsive':responsive}" style="overflow:visible;">
    <div>
      <table class="vuetable table table-hover" cellspacing="0" cellpadding="0" v-bind:class="tablecss" v-bind:id="'table_' +  getId()" data-showtoggle="false" data-show-toggle="false" data-expand-first="true">
        <thead>
          <tr style="background-color:initial">
            <th v-for="header in headerdata" v-bind:class="'tablecolumn tablecolumn-' + header.columnname" v-if="header.enabled == true" v-show="header.visible != false" v-bind:data-hide="header.datahide" v-bind:data-breakpoints="header.databreakpoints">
              <slot v-if="header.visible != false" v-bind:name="'header' + header.columnname" scope="testScope" :row="row">
                <a v-if="header.hideheader != true" @click="doSort(header.columnname)" class="mouseover-ul" v-html="'<nobr>' + header.headername + '</nobr>'"></a>
              </slot>
            </th>
            <th v-if="enableedit == 'true' " width="50" style="position:relative;min-width:50px;">
              <div style="position:absolute;top:0px;">
                <div class="skinnedmenu dropdown dropleft" style="position: relative; color: inherit;">
                  <a href="#" class="list-icons-item caret-0  font-weight-bold" data-toggle="dropdown" data-boundary="viewport" id="headerlink">
                    <i class="icon-menu" style="margin-top:6px;color:inherit;"></i>
                  </a>
                  <div class="skinnedmenu dropdown-menu dropdown-menu-left viewportfix pt-1" v-bind:class="menuclass" style="position:absolute">
                    <div class="container-fluid p-2 m-0" style="max-height:200px;overflow-y:auto" v-bind:style="'height:' + headerdata.length * 35 + 'px'">
                      <div class="row">
                        <div class="col-12">
                          <div v-for="header in headerdata" class="row">
                            <div class="col" v-if="header.visible != false">
                              <div class="custom-control custom-checkbox custom-control-inline mt-1">
                                <input class="custom-control-input" v-on:change="changedColumns" type="checkbox" v-model="header.enabled" v-bind:id="(header.headername +  getId())" />
                                <label class="custom-control-label" v-bind:for="(header.headername +  getId())">{{header.headername}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </th>
          </tr>
        </thead>

        <draggable v-model="tabledata" tag="tbody" v-bind="dragOptions" @end="dragEnd" ref="draggableobj">
          <tr v-bind:class="table-inactive">
            <td v-if="headerdata != null" v-bind:colspan="headerdata.length + 2"  style="height:100%;position:relative;">
              <div class="row" style="flex-wrap:unset;">
                <div class="col-12">
                  <a v-if="addButtonVisible == true" ref="addButton" v-on:click.self="add($event)" href="#" class="btn btn-link btn-light">+ Add</a>
                </div>
                <div class="col-12">
                  <textarea class="form-control" v-if="addButtonVisible == false" v-model="text"></textarea>
                </div>
                <div class="col-12 mt-1">
                  <a v-if="addButtonVisible == false" ref="doAdddButton" v-on:click.self="doAdd($event)" href="#" class="btn btn-link btn-primary text-light">Add</a>
                </div>
              </div>
            </td>
          </tr>
          <tr v-for="(row, index) in tabledata" v-bind:ref="getRowId(row)" v-bind:id="'row_' + index" v-bind:style="getRowStyle(row.color, row.selected)" v-bind:class="{'table-active':row.selected, 'table-inactive':!row.selected}" :key="row.transitionkey">
            <td v-for="header in headerdata" v-on:click.self.shift="selectMultiple($event, index)" v-on:click.self="select($event, index, row)" v-bind:class="'tablecolumn tablecolumn-' + header.columnname" v-bind:data-hide="header.datahide" v-bind:data-breakpoints="header.databreakpoints" v-if="header.enabled == true" v-show="header.visible != false" style="height:100%;position:relative;">
              <slot v-if="header.visible != false" v-bind:name="header.columnname" scope="testScope" :row="row" :index="index">
                {{row[header.columnname]}}
              </slot>
            </td>
            <td v-if="enableedit == 'true'" width="50" style="position: relative; min-width: 50px;">

              <div style="position:relative;">
                <div class="skinnedmenu dropdown dropleft" v-bind:class="menuclass" style="position:relative">
                  <a href="#" class="adminmenu list-icons-item caret-0 px-0" data-toggle="dropdown" data-boundary="viewport" id="headerlink" style="color: inherit;">
                    <span class="badge badge-pill ml-auto ml-lg-0 px-0" style="width:26px;">
                      <i class="icon-arrow-down22" style="color: inherit;"></i>
                    </span>
                  </a>
                  <div class="skinnedmenu dropdown-menu dropdown-menu-left pt-1" v-bind:class="menuclass" style="position:absolute">
                    <slot name="menu" scope="testScope" :row="row" :index="index" v-if="getSelected().length <= 1" :toggleShow="toggleShow"></slot>
                    <slot name="multiplemenu" scope="testScope" :row="row" :index="index" v-if="getSelected().length > 1" :toggleShow="toggleShow">
                      <div class="py-1" style="padding-left:15px !important">{{$t('multiple_selected')}}</div>
                    </slot>
                  </div>
                </div>

              </div>

            </td>
            <td v-if="enableedit == 'false'" width="50" style="position: relative; min-width: 50px;" v-on:click.shift="selectMultiple($event, index)" v-on:click="select($event, index, row)">

              <div class="skinnedmenu" v-bind:class="menuclass" style="position:relative">
                <span class="adminmenu badge badge-pill ml-auto ml-lg-0 px-0" style="width:26px;">
                  <i class="icon-arrow-right22 " style="color: inherit;"></i>
                </span>
              </div>

            </td>
          </tr>
        </draggable>
      </table>
    </div>
    <div class="text-center justify-content-center pt-2 col-12" style="overflow-x:auto;">
      <table-pagination @selectpage="onPageChange" v-if="enablePaging == true"
                        v-bind:currentpage="currentpage" v-bind:pages="pages"></table-pagination>
    </div>
  </div>

</template>

<script>


  var headerdata = [

  ];

  var tabledata = [
  ]

  var sortProperty = null;
  var sortDirection = 'ascending';

  import ColorUtils from "../utils/ColorUtils";
  import tablePagination from "./table-pagination.vue";
  import draggable from "vuedraggable";
  import { TimelineLite } from 'gsap'
  import { gsap } from 'gsap';

  var activeSubMenu = null;

  var disabledrag = true;
  var lastSelected = null;

  var animationTarget = null;
  const timeline = new TimelineLite({ paused: true })


  export default {
    name: "addable-table",
    components: {
      tablePagination,
      draggable,
      ColorUtils,
      TimelineLite,
      gsap,
    },
    props: {

      menuclass: {
        required: false,
        type: String,
        default: ""
      },
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      currentpage: {
        required: false,
        type: Number,
        default: 3
      },
      pages: {
        required: false,
        type: Number,
        default: 10
      },
      enablePaging: {
        required: false,
        type: Boolean,
        default: false
      },
      toggable: {
        required: false,
        type: Boolean,
        default: true
      },
      responsive: {
        required: false,
        type: Boolean,
        default: false
      },
      tablecss: {
        required: false,
        type: String,
        default: ""
      },
      ondragendfunc: {
        required: false,
        type: Function,
        default: null
      },
      enabledragging: {
        required: false,
        type: String,
        default: 'false'
      },
      tablename: {
        required: false,
        type: String,
        default: ''
      },
      rowclick: {
        required: false,
        type: String,
        default: ''
      },
      changedcolumns: {
        required: false,
        type: String,
        default: ''
      },
      isServerSorting: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        addButtonVisible: true,
        text: '',
        tabledata,
        headerdata,
        sortProperty,
        sortDirection,
        dragging: false,
        activeSubMenu,
        disabledrag,
        lastSelected,
        animationTarget,
        timeline,

      }
    },

    methods: {
      changedColumns() {
        if (this.changedcolumns != null) {
          eval(this.changedcolumns + "(this.headerdata)");
          Vue.set(this, "headerdata", this.headerdata)
        }
      },
      rowClick(index, row) {
        if (this.rowclick != null) {
          eval(this.rowclick + "(index,row,this)")
        }
      },
      onPageChange(pagenumber) {
        this.currentpage = pagenumber;
        var obj = { pagenumber: pagenumber, tablename: this.tablename };
        var data = JSON.stringify(obj);
        vm.$root.$emit('page_change', data);
        this.$emit('page_change', data);
      },
      setPaging(enablePaging, currentpage, totalRecods, perPageRecord=20) {
        this.enablePaging = enablePaging;
        this.currentpage = currentpage;

        var divide = totalRecods / perPageRecord;
        var round = Math.round(totalRecods / perPageRecord);
        if (round < divide) {
          round = round + 1;
        }

        this.pages = round;
      },
      getRowId(row) {
        var ref = "";
        for (var i = 0; i < this.headerdata.length; i++) {
          if (this.headerdata[i].isId == true) {
            var columnname = this.headerdata[i].columnname;
            ref += "dataid-" + row[columnname];
          }
        }
        return ref;
      },
      animate(target) {
        /*
        let b2 = "linear-gradient(17deg, rgba(255,0,0,.7), rgba(255,0,0,0) 70.71%), linear-gradient(200deg, rgba(0, 255, 0, .9), rgba(0,255,0,.2) 70.71%),  linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0.1) 70.71%)";

        let greenGradient = "linear-gradient(90deg, rgba(0,0,255,.8), rgba(0,0,255,0.1)  70.71%)";

        let greyGradient = "linear-gradient(90deg, rgba(204,204,204,1) 45%, rgba(246,247,247,1) 50%)";


        var thisContext = this;
        setTimeout(function () {
          const timeline2 = new TimelineLite()
          console.log(thisContext.$refs);

          timeline2.to(thisContext.$refs[target], { ease: "none", duration: 3, background: greyGradient })

        }, 100)
        */
      },

      animatePulsate(target, initial, targetcolor) {
        /*
        var thisContext = this;
        setTimeout(function () {
          const timeline2 = new TimelineLite()

          timeline2.fromTo(thisContext.$refs[target], { backgroundColor: initial }, { ease: "elastic", duration: 0.2, backgroundColor: targetcolor })
            .fromTo(thisContext.$refs[target], { backgroundColor: targetcolor }, { ease: "slow", duration: 0.5, backgroundColor: initial });

        }, 100)
        */
      },

      animateDone(target, percentage) {
        /*
        var firstStep = percentage + 15
        var secondStep = percentage / 2;
        let greyGradientstepInitial = "linear-gradient(90deg, rgba(202,226,163,1) 1%, rgba(246,247,247,1) 15%)"

        let greyGradientstep1 = "linear-gradient(90deg, rgba(202,226,163,1) " + (firstStep - 5) + "%, rgba(246,247,247,1) " + (firstStep + 5) + "%)";
        let greyGradientstep2 = "linear-gradient(90deg, rgba(202,226,163,1) " + (secondStep - 5) + "%, rgba(246,247,247,1) " + (secondStep + 5) + "%)";
        let greyGradientstep3 = "linear-gradient(90deg, rgba(202,226,163,1) " + (percentage) + "%, rgba(246,247,247,1) " + (percentage) + "%)";
        let reset = "";


        var thisContext = this;
        setTimeout(function () {
          const timeline2 = new TimelineLite()

          timeline2.set(thisContext.$refs[target], { background: greyGradientstepInitial })
            .fromTo(thisContext.$refs[target], { background: greyGradientstepInitial }, { ease: "power4", duration: 0.2, background: greyGradientstep1 })
            .fromTo(thisContext.$refs[target], { background: greyGradientstep1 }, { ease: "slow", duration: 0.5, background: greyGradientstep2 })
            .fromTo(thisContext.$refs[target], { background: greyGradientstep2 }, { ease: "elastic", duration: 1, background: greyGradientstep3 })
            .to(thisContext.$refs[target], { ease: "none", duration: 1, background: reset });

        }, 100)
        */
      },
      dragEnd(event) {
        if (this.ondragendfunc != null)
          this.ondragendfunc(event);
      },
      getId() {
        return this._uid;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      setHeaderData(headerData) {
        Vue.set(this, "headerdata", headerData)
      },
      sort() {
        var currentSortProperty = this.getSortProperty();
        var sorted = this.sortBy(this.tabledata, { prop: currentSortProperty, desc: this.getSortDirection() == "descending" });
        Vue.set(this, "tabledata", sorted)
      },
      doSort(property) {
        var currentSortProperty = this.getSortProperty();
        if (currentSortProperty == property) {
          this.toggleSortDirection();
        }
        else {
          this.setSortDirection("ascending");
        }
        this.setSortProperty(property);
        if (this.isServerSorting) {
          var obj = { property: property, tablename: this.tablename };
          var data = JSON.stringify(obj);
          vm.$root.$emit('basictable_column_sort', data);
        } else {
          var sorted = this.sortBy(this.tabledata, { prop: property, desc: this.getSortDirection() == "descending" });
          Vue.set(this, "tabledata", sorted)
        }
      },
      uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      getData() {
        return this.tabledata;
      },
      setData(headerData, tableData) {
        for (var i = 0; i < tableData.length; i++) {
          tableData[i].selected = false;
          tableData[i].transitionkey = this.uuidv4();
        }
        if (headerData != null)
          Vue.set(this, "headerdata", headerData)
        Vue.set(this, "tabledata", tableData);

      },
      render() {
        //this.$forceUpdate();
      },
      toggleSortDirection() {
        if (this.sortDirection == "ascending")
          this.sortDirection = "descending";
        else if (this.sortDirection == "descending")
          this.sortDirection = "ascending";
      },
      setSortDirection(direction) {
        this.sortDirection = direction;
      },
      getSortDirection() {
        return this.sortDirection
      },
      setSortProperty(property) {
        this.sortProperty = property;
      },
      getSortProperty() {
        return this.sortProperty;
      },
      getSelected() {
        var selectedItems = [];
        for (var i = 0; i < this.tabledata.length; i++) {
          if (this.tabledata[i].selected == true) {
            selectedItems.push(this.tabledata[i]);
          }
        }
        return selectedItems;
      },
      clearSelected() {
        for (var i = 0; i < this.tabledata.length; i++) {
          this.tabledata[i].selected = false;
        }
        this.lastSelected = null;
        Vue.set(this, "tabledata", this.tabledata)
      },
      setSelected(index) {
        if (index == null)
          return;
        //console.log('selected index(2):' + index);
        //console.log('tabledata length(2):' + this.tabledata.length);
        if (this.tabledata.length > 0 && this.tabledata.length > index) {
          this.tabledata[index].selected = true;
          this.lastSelected = index;
          Vue.set(this, "tabledata", this.tabledata)
        }
      },
      add(event) {
        alert("add")
        this.addButtonVisible = false;
      },
      doAdd($event) {
        alert(this.text);
        var data = this.getData()
        data.push({ Name: this.text });
        this.text = '';
        //this.setData(null, data);
        this.addButtonVisible = true;
        //this.$forceUpdate();
      },
      selectMultiple(event, index) {

        if (document.selection != null && document.selection.empty) {
          document.selection.empty();
        }
        else if (window.getSelection) {
          var sel = window.getSelection();
          sel.removeAllRanges();
        }

        var action = !this.tabledata[index].selected

        if (this.lastSelected != null) {

          if (index > this.lastSelected) {
            //console.log('selecting down the table');
            for (var i = this.lastSelected + 1; i < index; i++) {
              this.tabledata[i].selected = action;
            }
          }
          else if (index < this.lastSelected) {
            //console.log('selecting up the table');
            for (var i = this.lastSelected; i > index; i--) {
              this.tabledata[i].selected = action;
            }
          }
          else {
            this.tabledata[index].selected = action;
          }
        }

        this.lastSelected = index;
        event.preventDefault();

      },
      select(event, index, row) {

        this.tabledata[index].selected = !this.tabledata[index].selected;
        this.lastSelected = index;

        if (!this.isShift(event)) {
          this.rowClick(index, row);
        }
      },
      isShift(ev) {
        var key;
        var isShift = false;
        if (window.event) {
          key = window.event.keyCode;
          isShift = !!window.event.shiftKey; // typecast to boolean
        } else {
          key = ev.which;
          isShift = !!ev.shiftKey;
        }
        return isShift;
      },
      toggleShow(id) {
        this.activeSubMenu = id;
        $(id).toggleClass("show");
      },
      resetMenu() {
        if (this.activeSubMenu != null) {
          $(this.activeSubMenu).removeClass("show");
          this.activeSubMenu = null;
        }
      },
      getTextColor(color) {
        /*
        var islight = true;
        if (color != null) {
          islight = ColorUtils.isLight(color);
        }
        if (islight == false) {
          return "color:white !important;"
        }
        return "color:#333 !important;"*/
        return "";
      },
      getRowColor(color, selected) {
        if (color == null || typeof (color) == "undefined") {
          //  color = "#F6F7F7";
        }
        if (selected) {
          if (ColorUtils.isLight(color))
            return ColorUtils.blendColor(-0.2, color)
          return ColorUtils.blendColor(-0.6, color)
        }
        return color;
      },
      getCellColor(color, selected) {
        if (color == null || typeof (color) == "undefined") {
          //  color = "#F6F7F7";
        }
        if (selected) {
          if (ColorUtils.isLight(color))
            return ColorUtils.blendColor(-0.2, color)
          return ColorUtils.blendColor(-0.6, color)
        }
        return color;
      },
      getRowStyle(color, selected) {
        var tmpcolor = "#F6F7F7";
        if (color != null) {
          tmpcolor = color.slice();
        }
        if (selected) {
          tmpcolor = this.getRowColor(tmpcolor, selected)
        }
        var returnStr = "";
        if (this.rowclick != null) {
          returnStr = "cursor:pointer;"
        }
        returnStr += this.getTextColor(tmpcolor, selected) + 'background-color:' + tmpcolor;
        //returnStr += this.getTextColor(tmpcolor, selected);
        return returnStr;
      },
      sortBy:
        (function () {
          var toString = Object.prototype.toString,
            // default parser function
            parse = function (x) { return x; },
            // gets the item to be sorted
            getItem = function (x) {
              var isObject = x != null && typeof x === "object";
              var isProp = isObject && this.prop in x;
              return this.parser(isProp ? x[this.prop] : x);
            };

          /**
           * Sorts an array of elements.
           *
           * @param  {Array} array: the collection to sort
           * @param  {Object} cfg: the configuration options
           * @property {String}   cfg.prop: property name (if it is an Array of objects)
           * @property {Boolean}  cfg.desc: determines whether the sort is descending
           * @property {Function} cfg.parser: function to parse the items to expected type
           * @return {Array}
           */
          return function sortby(array, cfg) {
            if (!(array instanceof Array && array.length)) return [];
            if (toString.call(cfg) !== "[object Object]") cfg = {};
            if (typeof cfg.parser !== "function") cfg.parser = parse;
            cfg.desc = !!cfg.desc ? -1 : 1;
            return array.sort(function (a, b) {
              a = getItem.call(cfg, a);
              b = getItem.call(cfg, b);
              return cfg.desc * (a < b ? -1 : +(a > b));
            });
          };
        }())
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          disabled: false,
          ghostClass: "ghost",
          animation: 500,
          disabled: this.disabledrag
        };
      }
    },
    mounted() {


      if (this.enabledragging == "true")
        this.disabledrag = false;
      else
        this.disabledrag = true;

      //this.$refs.draggableobj.options.disabled = true;
      if (this.toggable) {
        if (!$().footable) {
          console.warn('Warning - footable.min.js is not loaded.');
          return;
        }
        $('#table_' + this.getId()).footable({
          "showToggle": false
        });
      }
    },

    created: function () {

    },

    watch: {

    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .adminmenu::after {
    content: "\A";
    position: absolute;
    width: 68%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.06);
    opacity: 1;
    transition: all 1s;
    -webkit-transition: all 1s;
    border-radius: 50rem !important;
  }

  .adminmenu:hover::after {

    background: rgba(0,0,0,.1);
    transition: all 1s;
    -webkit-transition: all 1s;
    border-radius: 50rem !important;
  }

  .icon-menu {
    color: #a4a4a4;
  }

  .footable-toggle {
    display: none;
  }

  .mouseover-ul {
    /*color: #7c7c7c !important;*/
  }

    .mouseover-ul:hover {
      text-decoration: underline !important;
      cursor: pointer;
    }

  .table-active {
    border-bottom: 1px solid #ccc;
  }

  .dropleft .dropdown-toggle::before {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/tables/addable-table.vue